import { useEffect } from 'react';
import { IS_DEMO_MODE } from 'config/demo';

interface UseQueryProps {
  title: string;
}

const DEMO_TITLE_SUFFIX = 'Portfolio Demo';
const DEFAULT_TITLE = IS_DEMO_MODE
  ? `Cosmic NFT Marketplace — ${DEMO_TITLE_SUFFIX}`
  : 'Cosmic NFT Marketplace';

const useTitle = ({ title }: UseQueryProps): void => {
  useEffect(() => {
    document.title = title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
};

export default useTitle;
